import React, { useCallback, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import parse from "html-react-parser";
import { faArrowRight, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { IoIosArrowForward, IoIosArrowDown } from "react-icons/io";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import Rangeslider from "../../../common/rangeslider/Rangeslider";
import { categories } from "../../../common/categoriesdata/Categoriesdata";
import CompanyLogo from "../../../common/CompanyLogo";
import { useDispatch, useSelector } from "react-redux";
import Api_Instance from "../../../api/Api_Instance";
import { BASE_URL, CATEGORY, endpoints } from "../../../api/endpoints";
import { extractNumericValue, STATE_DATA } from "../../../utils/Utils";
import { setCategoryid } from "../../../redux/slice/Slice";
import { useParams } from "react-router-dom";
import { IoEyeOutline } from "react-icons/io5";
import { IoHeart } from "react-icons/io5";
import { FaShareAlt } from "react-icons/fa";

function Automotive() {
  const api = Api_Instance.unAuth();
  const filterdata = useSelector((state) => state.auth.filterdata);
  const rangevalue = useSelector((state) => state.auth.rangevalue);
  const brandname = useSelector((state) => state.auth.brandname);
  const [categorydata, setCategoryData] = useState([]);
  const [subcategory, setSubCategory] = useState([]);
  const [statedata, setStatedata] = useState(filterdata);
  const [carddata, setCarddata] = useState([]);
  const [cards, setCards] = useState(filterdata);
  const [checked, setChecked] = useState(false);
  const [page, setPage] = useState(1); // Pagination state
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true); // To track if more testimonials are available
  const [serach, setSearch] = useState("");
  const [state_filter, setstateFilter] = useState([])
  const getAlldata = async (pageNumber) => {
    try {
      const response = await api("GET", `${endpoints.BUSSINESS_API}?page_size=6&page=${pageNumber}`);
      setCarddata(response.data.data);
    } catch (error) { }
  };

  useEffect(() => {
    setStatedata(filterdata)
  }, [filterdata])
  useEffect(() => {
    setStatedata((prevData) => [...state_filter]);
    setCards((prevData) => [...prevData, ...state_filter]);
  }, [state_filter])
  const handlechangedata = (val) => {
    console.log(val, 'valfdsfdsf')
    setStatedata(val);
    setCards(val);
    const data = val
  }
  const handleChangeState = async (val, isChecked) => {
    if (isChecked) {
      try {
        const response = await api("GET", `${endpoints.BUSSINESS_API}?state=${val}`);
        if (response?.data?.data?.length > 0) {
          setStatedata([]);
          setCards([]);
          setstateFilter(response?.data?.data)
          handlechangedata(response?.data?.data)
        }
      } catch (error) {

      }

      setChecked(isChecked);

    } else {
      const newStateData = statedata?.filter(
        (item) => item.state.toLowerCase() !== val.toLowerCase()
      );
      setStatedata(newStateData);
      setCards(newStateData);
    }
  };
  const extractRange = (investment) => {
    const parts = investment?.split("-").map((part) => part?.trim());

    const parseValue = (value) => {
      let numericValue = value
        .replace(/₹|,/g, "")
        .replace(/K/gi, "000")
        .replace(/LAC/gi, "00000")
        .replace(/CR/gi, "0000000");

      return parseInt(numericValue.replace(/[^0-9]/g, ""), 10);
    };

    const min = parseValue(parts[0]);
    const max = parts[1] ? parseValue(parts[1]) : min;

    return {
      min,
      max,
    };
  };
  useEffect(() => {
    const filteredData = cards?.filter((item) => {
      const itemRange = extractRange(
        item?.investment ? item?.investment : "10K - 1 LAC"
      );
      return (
        (itemRange.min >= rangevalue.min && itemRange.min <= rangevalue.max) ||
        (itemRange.max >= rangevalue.min && itemRange.max <= rangevalue.max) ||
        (itemRange.min <= rangevalue.min && itemRange.max >= rangevalue.max)
      );
    });
    setStatedata(filteredData);
  }, [rangevalue, checked]);
  const handleserach = (e) => {
    const val = e.target.value;
    setSearch(val);
    if (val.length) {
      const filteredData = cards?.filter((item) =>
        item.state.toLowerCase().includes(val)
      );
      setStatedata(filteredData);
    } else {
      setStatedata(cards);
    }
  };

  const cardData = statedata;
  const itemsPerPage = 6;
  const totalPages = Math.ceil(cardData?.length / itemsPerPage);
  const [currentPage, setCurrentPage] = useState(1);

  // Calculate pagination boundaries
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = cardData?.slice(indexOfFirstItem, indexOfLastItem);

  useEffect(() => {
    getAlldata(page);
    // setRangeValues(rangevalue);
  }, [rangevalue]);

  // Change page
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    getAlldata(pageNumber)
  };

  // Previous page
  const previousPage = () => {
    if (currentPage > 1) {
      const pageNo = currentPage - 1
      getAlldata(pageNo)
      setCurrentPage(currentPage - 1);
    }
  };

  // Next page
  const nextPage = () => {
    if (currentPage < totalPages) {
      const pageNo = currentPage + 1
      getAlldata(pageNo)
      setCurrentPage(currentPage + 1);
    }
  };

  const renderPagination = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
      // Display up to 4 pages directly, then show ... before the last page
      if (
        i === 1 ||
        i === currentPage ||
        i === totalPages ||
        (i >= currentPage - 1 && i <= currentPage + 1)
      ) {
        pageNumbers.push(i);
      }
    }
    return pageNumbers.map((number) => (
      <button
        key={number}
        onClick={() => paginate(number)}
        className={`mx-1 px-3 py-1 border rounded-md ${currentPage === number
          ? "bg-primaryColor text-white"
          : "bg-subheader_background text-gray-700"
          }`}
      >
        {number}
      </button>
    ));
  };
  const cateGoryApi = async () => {
    try {
      const res = await api("GET", CATEGORY.GET_CATEGORY);
      setCategoryData(res?.data?.data);
    } catch (error) { }
  };

  useEffect(() => {
    cateGoryApi();
  }, []);

  return (
    <div>
      <CompanyLogo
        title={brandname}
        subtitle={brandname}
      />

      <div className="w-full max-w-[1250px]     mx-auto xl:px-0 lg:px-0 md:px-5 px-4 mt-20 2xl:mt-5 xl:mt-5 lg:mt-5 md:mt-2 mt-2 flex flex-col md:flex-row">
        <div className=" w-full  p-2 items-center md:flex md:justify-between">
          <p className="text-[#B3B3B3] mb-3 md:!mb-0">
            Showing {currentPage} of {totalPages}
          </p>
          <div className="relative w-full md:w-auto">
            <div className="flex items-center justify-center w-full">
              <input
                type="text"
                name="serach"
                value={serach}
                onChange={(e) => handleserach(e)}
                placeholder="Search..."
                className="w-full h-10 border-2 text-center p-2 rounded-lg border-[#4a5661]"
              />
              <img
                className="absolute left-3 top-1/2 transform -translate-y-1/2 bg-white"
                src="../../../../../img/search (2) 1.svg"
                alt="search icon"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="w-full max-w-[1250px]     mx-auto xl:px-0 lg:px-0 md:px-5 px-4 mt-20 flex flex-col md:flex-row mx-auto 2xl:mt-5 xl:mt-5 lg:mt-5 md:mt-2 mt-2 2xl:p-0 xl:p-0 lg:p-0 md:px-1 px-2">
        <div className="flex flex-col md:flex-row w-full">
        <div className="w-full  md:w-[30%] lg:w-[25%]">
            <div className="flex flex-col space-y-10 w-full">

              <div className="p-2 h-32 w-full  bg-card_bg_color rounded-lg">
                <h3 className="text-primaryColor text-xl text-start font-semibold mt-2">
                  Price Range
                </h3>
                <Rangeslider
                  min={0}
                  max={10000000}
                  onChange={({ min, max }) => {

                  }}
                />
              </div>
              <div className="p-2 h-[400px] w-full bg-card_bg_color rounded-lg">
                <h3 className="text-primaryColor text-xl font-semibold mt-2">
                  Location
                </h3>
                <div className=" overflow-y-auto h-[310px]">
                  {STATE_DATA?.map((category) => (
                    <div
                      className="flex gap-2 items-center mt-2"
                      key={category.id}
                    >
                      <span>
                        <input
                          type="checkbox"
                          className="text-gray-600"
                          onChange={(e) =>
                            handleChangeState(category?.value, e.target.checked)
                          }
                        />
                      </span>
                      <p className="text-gray-600">{category?.value}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
      

          <div className="w-full pt-5 md:!pt-0 md:w-[70%]  lg:w-[75%]">
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 md:mt-0 gap-4 md:ml-[21px] ">
              
              {currentItems.length > 0 ? currentItems?.map((item) => item?.status && (
                <div
                  key={item}
                  className="bg-[#f6f5f5] w-full  p-2 flex flex-col justify-between rounded-lg [box-shadow:inset_0_1px_1px_rgba(0,_0,_0,_.075),_0_0_8px_rgb(0_0_0_/_20%)]"
                >
                  <div className="flex mt-2 gap-4 flex-grow">
                    <div className="flex justify-center items-center sm:h-32  lg:h-20 w-32 overflow-hidden">
                      <div className="">
                        <img
                          src={`${item?.upload_logo}`}
                          alt="img"
                          className="object-fit w-full h-full"
                        />
                      </div>
                    </div>

                    <div className="flex flex-col flex-grow">
                      <h1 className="text-xl font-bold w-[150px] overflow-hidden overflow-ellipsis whitespace-nowrap">{item?.brand_name}</h1>
                      <div className="flex items-center">
                        <p className="text-sm  text-[#666666] font-semibold flex-[0_0_50%] whitespace-nowrap">
                          Establishment Year:
                        </p>
                        <p className="text-primaryColor text-sm ps-2 flex-[0_0_50%]">
                          {item?.establish_year}
                        </p>
                      </div>
                      <div className="flex items-center">
                        <p className="text-sm text-[#666666] font-semibold flex-[0_0_50%] whitespace-nowrap">
                          Franchise Start:
                        </p>
                        <p className="text-primaryColor text-sm ps-2 flex-[0_0_50%]">
                          {" "}
                          {item?.franchise_start}
                        </p>
                      </div>

                    </div>
                  </div>
                  <div className="mt-2">
                    {/* <p className="text-gray-600 text-ellipsis overflow-hidden whitespace-nowrap max-w-xs">
                 {parse(item?.business_overview)}
               </p> */}

                    <div className="flex justify-between text-gray-700 mb-1">
                      <p className="flex-[0_0_50%] whitespace-nowrap">Investment Range</p>
                      <p className="font-semibold text-start 2xl:flex-[0_0_50%] flex-[0_0_35%] w-[200px] overflow-hidden overflow-ellipsis whitespace-nowrap">{item?.investment}</p>
                    </div>
                    <div className="flex justify-between text-gray-700 mb-1">
                      <p className="flex-[0_0_50%] whitespace-nowrap">Space required</p>
                      <p className="font-semibold text-start 2xl:flex-[0_0_50%] flex-[0_0_35%] w-[200px] overflow-hidden overflow-ellipsis whitespace-nowrap">{item?.required_area}</p>
                    </div>
                    <div className="flex justify-between text-gray-700 mb-1">
                      <p className="flex-[0_0_50%] whitespace-nowrap">Franchise Outlets</p>
                      <p className="font-semibold text-start 2xl:flex-[0_0_50%] flex-[0_0_35%] w-[200px] overflow-hidden overflow-ellipsis whitespace-nowrap">{item?.brand_outlet}</p>
                    </div>
                    <div className="flex justify-between text-gray-700 mb-1">
                      <p className="flex-[0_0_50%] whitespace-nowrap">Franchise Type</p>
                      <p className="font-semibold text-start 2xl:flex-[0_0_50%] flex-[0_0_35%] w-[200px] overflow-hidden overflow-ellipsis whitespace-nowrap">{item?.franchise_model}</p>
                    </div>
                    <div className="flex justify-between text-gray-700 mb-1">
                      <p className="flex-[0_0_50%] whitespace-nowrap">State</p>
                      <p className="font-semibold text-start 2xl:flex-[0_0_50%] flex-[0_0_35%] w-[200px] overflow-hidden overflow-ellipsis whitespace-nowrap">{item?.state}</p>
                    </div>
                    {/* <div className="flex justify-between mt-3">
                      <div className="flex gap-1 text-sm text-[#0098c7] border-[#4A5661] border-1 p-2 rounded-lg cursor-pointer">
                        <IoEyeOutline className="text-[20px] text-[#4A5661]" />
                        <p className="text-[#4A5661]">{item?.views} View</p>
                      </div>
                      <div className="flex gap-1 text-sm text-[#0098c7] border-[#4A5661] border-1 p-2 rounded-lg cursor-pointer">
                        <IoHeart className="text-[20px] text-[#4A5661]" />
                        <p className="text-[#4A5661]">{item?.likes} Like</p>
                      </div>
                      <div className="flex gap-1 text-sm text-[#0098c7] border-[#4A5661] border-1 p-2 rounded-lg cursor-pointer">
                        <FaShareAlt className="text-[20px] text-[#4A5661]" />
                        <p className="text-[#4A5661]">Share</p>
                      </div>
                    </div> */}
                    <NavLink to="/franchise-opportunity/best-bussinessdetails" state={{ item: item }}>
                      <div className="bg-[#4A5661] text-white rounded-md border-gray-600 mt-4 text-center text-sm text-gray-800 py-2 cursor-pointer w-60hover:[box-shadow:0_0_10px_0_#0098c6_inset,0_0_20px_2px#0096c48c]">
                        <p className="">
                          Explore
                          <FontAwesomeIcon icon={faArrowRight} className="ml-2" />
                        </p>
                      </div>
                    </NavLink>
                  </div>
                </div>
              )) : "No data avilable"}

            </div>

   {/* Pagination */}
   <div className="flex justify-center mt-5">
        <button
          onClick={previousPage}
          className={`mx-1 px-3 py-1 border rounded-md ${currentPage === 1
            ? "bg-subheader_background text-gray-700"
            : "bg-primaryColor text-white"
            }`}
          disabled={currentPage === 1}
        >
          <FontAwesomeIcon icon={faArrowLeft} />
        </button>

        {/* Render pagination numbers */}
        {renderPagination()}

        <button
          onClick={nextPage}
          className={`mx-1 px-3 py-1 border rounded-md ${currentPage === totalPages
            ? "bg-subheader_background text-gray-700"
            : "bg-primaryColor text-white"
            }`}
          disabled={currentPage === totalPages}
        >
          <FontAwesomeIcon icon={faArrowRight} />
        </button>
      </div>
          </div>
          <div>
          </div>
        </div>
      </div>
   
    </div>
  );
}

export default Automotive;
